// extracted by mini-css-extract-plugin
export default {"cardNotif":"UserMenu_cardNotif__PXu2Z","productImg":"UserMenu_productImg__-DfmR","icon":"UserMenu_icon__-jdS9","navbar-toggle":"UserMenu_navbar-toggle__kKSjb"};